'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Status = require('./Status.js');

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.getStatus = function (params) {
    var category = params.category;
    var time = params.time;

    if (!category.properties) {
        return { 'status': 'available', until: Number.MAX_VALUE };
    }

    var properties = JSON.parse(category.properties["com.implied2.spice"] || "{\"inactive\":false}");

    if (properties.inactive) {
        return { 'status': 'unavailable', until: Number.MAX_VALUE };
    }

    var times = properties.availability || { weekly: [], exceptions: [] };

    return _Status2.default.getStatus(times, time);
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Category.js
// module id = 456
// module chunks = 0